import React from 'react'

import { DataTableProvider } from '@procsea/design-system'

const getRowCountText = ({
  totalCount,
  selectedCount,
  isAllSelected,
}: {
  totalCount: number
  selectedCount: number
  isAllSelected: boolean
}) => {
  const baseText = interpolate(
    ngettext('%(totalCount)s row', '%(totalCount)s rows', totalCount),
    { totalCount: totalCount.toString() },
    true
  )

  if (isAllSelected) {
    return `${baseText} (${gettext('all selected')})`
  }

  if (selectedCount > 0) {
    const selectedText = interpolate(
      ngettext('%(selectedCount)s selected', '%(selectedCount)s selected', selectedCount),
      { selectedCount: selectedCount.toString() },
      true
    )
    return `${baseText} (${selectedText})`
  }

  return baseText
}

// SelectAllBanner translations
const selectAllBannerAllSelectedText = (count: number) =>
  interpolate(
    ngettext(
      'The %(count)s available item is selected.',
      'All %(count)s available items are selected.',
      count
    ),
    { count: count.toString() },
    true
  )

const selectAllBannerVisibleSelectedText = (count: number) =>
  interpolate(
    ngettext('%(count)s visible item selected.', '%(count)s visible items selected.', count),
    { count: count.toString() },
    true
  )

const selectAllBannerSelectAllText = (count: number) =>
  interpolate(
    ngettext('Select the %(count)s item', 'Select all %(count)s items', count),
    { count: count.toString() },
    true
  )

interface ConfiguredDataTableProviderProps {
  children: React.ReactNode
}

const ConfiguredDataTableProvider = ({ children }: ConfiguredDataTableProviderProps) => (
  <DataTableProvider
    actionBarFeedbackButtonLabel={gettext('Tell Us What You Think')}
    actionMenuButtonLabel={gettext('Actions')}
    actionMenuTitle={gettext('Actions')}
    configMenuOpenButtonLabel={gettext('Configuration')}
    configMenuTitle={gettext('Table configuration')}
    configMenuPinnedColumnSubTitle={gettext('Pinned columns')}
    configMenuRemainingColumnSubTitle={gettext('Remaining columns')}
    configMenuResetButtonLabel={gettext('Reset')}
    configMenuSaveButtonLabel={gettext('Save')}
    configMenuUndoButtonLabel={gettext('Undo')}
    countFetchingText={gettext('Fetching...')}
    getRowCountText={getRowCountText}
    configMenuPinColumnButtonTooltip={gettext('Pin column')}
    sortAscending={gettext('Sort ascending')}
    sortDescending={gettext('Sort descending')}
    cleanSort={gettext('Clean sort')}
    selectAllBannerAllSelectedText={selectAllBannerAllSelectedText}
    selectAllBannerClearSelectionText={gettext('Clear selection')}
    selectAllBannerSelectAllText={selectAllBannerSelectAllText}
    selectAllBannerVisibleSelectedText={selectAllBannerVisibleSelectedText}
  >
    {children}
  </DataTableProvider>
)

export default ConfiguredDataTableProvider
